import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ItemsWithHandoverDataRoadReport
  from '../../components/ItemsWithHandoverDataRoadReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ItemsWithHandoverDataRoadDetailsSelectors';

export function ItemsHandoverDataRoadDetailsContainer(props) {
  return (
    <ItemsWithHandoverDataRoadReport
      reportId={ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ItemsHandoverDataRoadDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ItemsHandoverDataRoadDetailsContainer);
